import { store } from "@/stores/store";
import { openSelectBrandDialog } from "@/components/header/dialogs/SelectBrandDialog.vue";
import SelectBrandDialog from "./dialogs/SelectBrandDialog.vue";
export default {
  name: "HeaderBrand",
  data() {
    return {
      store
    };
  },
  methods: {
    open() {
      openSelectBrandDialog();
    }
  },
  components: {
    SelectBrandDialog
  }
};